export const CommonModelFamiliesValues = ['q5-new', 'a5-new', 'q4', 'q6etron', 'q7'];
